import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=71af53f3&scoped=true"
import script from "./Merch.vue?vue&type=script&lang=js"
export * from "./Merch.vue?vue&type=script&lang=js"
import style0 from "./Merch.vue?vue&type=style&index=0&id=71af53f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af53f3",
  null
  
)

export default component.exports